import React from 'react';

import { MenuDesktop } from './components/MenuDesktop';

import { componentService } from '@core/js/services/component.service';

import { useInDesktop } from '@interlayer/js/app/hooks/device/hooks/useMediaQuery';

const DefaultMenuWrapper: React.FC = () => {
    const isDesktop = useInDesktop();

    return isDesktop ? <MenuDesktop /> : null;
};

export const DefaultMenu = () => <DefaultMenuWrapper />;

componentService.registerWebContentComponents({ DefaultMenu });
